export interface PasswordCriteria {
  length: boolean
  uppercase: boolean
  lowercase: boolean
  number: boolean
  special: boolean
}

export const getPasswordCriteria = (password: string): PasswordCriteria => ({
  length: password.length >= 8,
  uppercase: /[A-Z]/.test(password),
  lowercase: /[a-z]/.test(password),
  number: /\d/.test(password),
  special: /[^A-Za-z0-9]/.test(password)
})

export const getPasswordStrength = (password: string): number => {
  const metCriteria = Object.values(getPasswordCriteria(password)).filter(Boolean).length
  return metCriteria * 20
}

export const isPasswordValid = (password: string): boolean => {
  return Object.values(getPasswordCriteria(password)).every(Boolean)
}
